import { render, staticRenderFns } from "./ShProductAddToCartBar.vue?vue&type=template&id=54dd5a97&scoped=true&"
import script from "./ShProductAddToCartBar.vue?vue&type=script&lang=js&"
export * from "./ShProductAddToCartBar.vue?vue&type=script&lang=js&"
import style0 from "./ShProductAddToCartBar.vue?vue&type=style&index=0&id=54dd5a97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd5a97",
  null
  
)

export default component.exports